import React from "react";
import Select from "../../../../../../../../common/StyledSelect";
import CustomTextField from "../../../../common/CustomTextField";
import { withStyles } from "@material-ui/core/styles";
import { MAX_LENGTH_CONSTRAINTS, MAX_VALUE_CONSTRAINTS, MIN_VALUE, EXCEPTION_CODE } from "../../../../common/constants";

const styles = (theme) => ({
  fullWidth: { width: "100%" },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  warningText: {
    color: theme.warningTextColorDispatch,
    fontSize: theme.textFontSize
  },
});

class DeliveryExceptionDefault extends React.Component {
  handleChange = (name) => (value) => {
    const { handleChange } = this.props;
    if (name == "exceptionPackageType") {
      value = value && value.value;
    }
    handleChange && handleChange(name)(value);
  };

  render() {
    const { classes, packageTypeList, editInfo, errorInfo, shipmentPieces } = this.props;
    const warning = editInfo.exceptionType === EXCEPTION_CODE.DELIVERY_SHORT && editInfo.exceptionPieces >= shipmentPieces
    return (
      <React.Fragment>
        <CustomTextField
          className={classes.fullWidth}
          id="exceptionPieces"
          label="Exception Pieces"
          type="number"
          handleChange={this.handleChange("exceptionPieces")}
          error={errorInfo.exceptionPieces}
          value={editInfo.exceptionPieces}
          inputProps={{
            min: MIN_VALUE.DELIVERY_PRO_FORM.DE_PIECES,
            max: MAX_VALUE_CONSTRAINTS.DELIVERY_PRO_FORM.DE_PIECES,
          }}
        />
        {warning ? (
          <div className={classes.warningText}>Exception pieces are equal to or more than billed pieces.</div>
        ) : null}
        <div className={classes.flexRow}>
          <Select
            textFieldProps={{
              id: "exceptionPackageType",
              label: "Package Type",
              variant: "outlined",
              helperText: errorInfo.exceptionPackageType,
            }}
            value={editInfo.exceptionPackageType}
            error={Boolean(errorInfo.exceptionPackageType)}
            onChange={this.handleChange("exceptionPackageType")}
            data={packageTypeList}
          />
        </div>
        <CustomTextField
          id="exceptionDescription"
          handleChange={this.handleChange("exceptionDescription")}
          error={errorInfo.exceptionDescription}
          value={editInfo.exceptionDescription}
          className={classes.fullWidth}
          label="Exception Description"
          multiline
          rows={4}
          inputProps={{
            maxLength: MAX_LENGTH_CONSTRAINTS.DELIVERY_PRO_FORM.DE_COMMENTS,
            focused: true,
          }}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(DeliveryExceptionDefault);
